import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { CommandHandler } from '@/app/tracking/api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { timeIntervalFromSeconds, timeIntervalToString } from '@/app/tracking/scorm/2004/api';
import { UpdateSessionTimeCommand, UpdateSessionTimeCommandPayload } from '../api'

const debug = Debug('scorm2004-update-session-time-command-handler')

@injectable()
export class Scorm2004UpdateSessionTimeCommandHandler implements CommandHandler<UpdateSessionTimeCommand> {

  constructor (
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }
  
  public async execute(command: UpdateSessionTimeCommandPayload) {

    debug('execute, seconds: ', command.sessionTimeSeconds)

    const timeInterval = timeIntervalFromSeconds(command.sessionTimeSeconds)
    this.client.setValue('cmi.session_time', timeIntervalToString(timeInterval));
    this.client.commit()
  }
}
